const home = r => require.ensure([], () => r(require('@/page/home.vue')), 'home')
const community = r => require.ensure([], () => r(require('@/page/community/community.vue')), 'community')
const community_category = r => require.ensure([], () => r(require('@/page/community/category.vue')), 'community')
const community_list = r => require.ensure([], () => r(require('@/page/community/list.vue')), 'community')
const community_detail = r => require.ensure([], () => r(require('@/page/community/detail.vue')), 'community')
const history = r => require.ensure([], () => r(require('@/page/community/history.vue')), 'community')

const culture = r => require.ensure([], () => r(require('@/page/culture/culture.vue')), 'culture')
const culture_category = r => require.ensure([], () => r(require('@/page/culture/category.vue')), 'culture')
const culture_list = r => require.ensure([], () => r(require('@/page/culture/list.vue')), 'culture')
const culture_content = r => require.ensure([], () => r(require('@/page/culture/content.vue')), 'culture')
const culture_article = r => require.ensure([], () => r(require('@/page/culture/article.vue')), 'culture')

const train = r => require.ensure([], () => r(require('@/page/train/train.vue')), 'train')
const train_detail = r => require.ensure([], () => r(require('@/page/train/detail.vue')), 'train')
const train_examine = r => require.ensure([], () => r(require('@/page/train/examine.vue')), 'train')
const train_mycer = r => require.ensure([], () => r(require('@/page/train/mycer.vue')), 'train')

const examine_result = r => require.ensure([], () => r(require('@/page/train/result.vue')), 'train')
const examine_certificate = r => require.ensure([], () => r(require('@/page/train/certificate.vue')), 'train')

const album = r => require.ensure([], () => r(require('@/page/download/album.vue')), 'download')
const download_detail = r => require.ensure([], () => r(require('@/page/download/detail.vue')), 'download')


const help = r => require.ensure([], () => r(require('@/page/show/help.vue')), 'show')
const search = r => require.ensure([], () => r(require('@/page/show/search.vue')), 'show')
const contact = r => require.ensure([], () => r(require('@/page/show/contact.vue')), 'show')
const video = r => require.ensure([], () => r(require('@/page/show/video.vue')), 'show')
const guide = r => require.ensure([], () => r(require('@/page/show/guide.vue')), 'show')
const guide1 = r => require.ensure([], () => r(require('@/page/show/guide1.vue')), 'show')
const guide_detail = r => require.ensure([], () => r(require('@/page/show/guidedetail.vue')), 'show')
const intoVideoService = r => require.ensure([], () => r(require('@/page/show/intoVideoService.vue')), 'show')

const maintain = r => require.ensure([], () => r(require('@/page/maintain.vue')), 'maintain')

const cnoil = r => require.ensure([], () => r(require('@/page/cnoil/index.vue')), 'cnoil')
const cnoil_detail = r => require.ensure([], () => r(require('@/page/cnoil/detail.vue')), 'cnoil')
export default [{
	path: '/home',
	component: home,
	meta: {
		code:'WSFT_Home',
		requireAuth: false
	}
},{
	path: '/maintain',
	component: maintain,
	meta: {
		requireAuth: false
	}
},{
	path: '/community',
	component: community,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: false
	}
},{
	path: '/community/category',
	component: community_category,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: false
	}
},{
	path: '/community/list',
	component: community_list,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: false
	}
},{
	path: '/community/article',
	component: community_detail,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: false
	}
},{
	path: '/community/history',
	component: history,
	meta: {
		code:'',
		requireAuth: false
	}
},{
	path: '/culture',
	component: culture,
	meta: {
		code:'DT_WS_CultureCatalog',
		requireAuth: false
	}
},{
	path: '/culture/category',
	component: culture_category,
	meta: {
		code:'DT_WS_CultureCatalog',
		requireAuth: false
	}
},{
	path: '/culture/list',
	component: culture_list,
	meta: {
		code:'DT_WS_CultureCatalog',
		requireAuth: false
	}
	
},{
	path:'/culture/content',
	component: culture_content,
	meta: {
		code:'DT_WS_CultureCatalog',
		requireAuth: false
	}
},{
	path:'/culture/article',
	component: culture_article,
	meta: {
		code:'DT_WS_CultureCatalog',
		requireAuth: false
	}
},{
	path: '/train',
	component: train,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: true,
	}
},{
	path: '/train/detail',
	component: train_detail,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: true,
	}
	
},{
	path: '/train/examine',
	component: train_examine,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: true,
	}
},{
	path: '/train/mycer',
	component: train_mycer,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: true,
	}
},{
	path: '/train/result',
	component: examine_result,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: true,
	}
},{
	path: '/train/certificate',
	component: examine_certificate,
	meta: {
		code:'DT_WS_CommunityCatalog',
		requireAuth: true,
	}
},{
	path: '/download/album',
	component: album,
	meta: {
		code:'DT_WS_DownloadCatalog',
		requireAuth: false
	}	
},{
	path: '/download/album/detail',
	component: download_detail,
	meta: {
		code:'DT_WS_DownloadCatalog',
		requireAuth: false
	}	
},{
	path: '/show/help',
	component: help,
	meta: {
		code:'DT_WS_HelpCenterCatalog',
		requireAuth: false
	}
},{
	path: '/show/search',
	component: search,
	meta: {
		code:'',
		requireAuth: false
	}
},{
	path: '/show/video',
	component: video,
	meta: {
		code:'',
		requireAuth: false
	}
},{
	path: '/show/guide',
	component: guide,
	meta: {
		code:'WSFT_Guide',
		requireAuth: false
	}
	
},{
	path: '/show/guide1',
	component: guide1,
	meta: {
		code:'WSFT_Guide',
		requireAuth: false
	}
	
},{
	path: '/show/guide/detail',
	component: guide_detail,
	meta: {
		code:'WSFT_Guide',
		requireAuth: false
	}
	
},{
	path: '/show/article',
	component: community_detail,
	meta: {
		code:'',
		requireAuth: false
	}
},{
	path: '/show/contact',
	component: contact,
	meta: {
		code:'WSFT_Abount',
		requireAuth: false
	}
},{
	path: '/show/intoVideoService',
	component: intoVideoService,
	meta: {
		code:'',
		requireAuth: true
	}
},{
	path: '/cnoil',
	component: cnoil,
	meta: {
		requireAuth: false
	}
},{
	path: '/cnoil/detail',
	component: cnoil_detail,
	meta: {
		requireAuth: false
	}
}]